<template>
  <div class="index">
    <Title titleName='订单中心'/>

    <div class="mem-con">
      <div class="mem-l1">
        <van-row>
          <van-col span='6'>
            <router-link to="user">
              <img class="head" :src="user.avatar" />
            </router-link>
          </van-col>
          <van-col span='14'>
            <h3> {{user.nickname}}</h3>

          </van-col>
          <van-col span='4'  class="mem-sim" >


            <h4>{{user.points||0}}</h4>
            <p>我的积分</p>


          </van-col>
        </van-row>

      </div>



    </div>
    <!--    <div class="pro-tab">-->

    <!--      <van-tabs color="#FF5E00"  title-active-color="#FF5E00" v-model="type" @click="selecttype" :ellipsis="false">-->
    <!--        <van-tab title-style="font-weight: bold" title="订单一" name="1" ></van-tab>-->
    <!--        <van-tab title-style="font-weight: bold" title="订单二" name="2" ></van-tab>-->
    <!--      </van-tabs>-->
    <!--    </div>-->
    <div class="pro-tab">

      <van-tabs color="#FF5E00"  title-active-color="#FF5E00" v-model="id" @click="sandAlt" :ellipsis="false">
        <van-tab title-style="font-weight: bold" title="新订单" name="1" ></van-tab>
        <van-tab title-style="font-weight: bold" title="已报价" name="2" ></van-tab>
        <van-tab :info="dainum" title-style="font-weight: bold" title="待出票" name="3" ></van-tab>
        <van-tab title-style="font-weight: bold" title="已出票" name="4" ></van-tab>
        <van-tab title-style="font-weight: bold" title="已关闭" name="5" ></van-tab>
        <van-tab title-style="font-weight: bold" title="退单转单" name="6" ></van-tab>

      </van-tabs>
    </div>
    <div class="notice" v-if="dainum>0">
      <img src="../../assets/not.png" />最新一笔待出票订单还有<van-count-down :time="timedai" format="mm 分 ss 秒" />自动关闭~
    </div>
    <div class="notice" v-else-if="id==1&&news.length>0">
      <img src="../../assets/not.png" />来{{news.length}}张新订单了~
    </div>

    <div class="word" v-if="id>1">
      <div class="m-search">
        <img src="../../assets/search.png" />
        <input type="text" v-model="keywords" placeholder="输入订单号、电影、影院、城市搜索"/>
      </div>
      <div class="h-button" @click="sandAlt">搜索</div>
    </div>

    <div class="index-product">

      <div class="con"  v-if="user.store_state==2">
        <!--		<div class="con" >-->
        <ul>
          <li v-for="it in news">
            <img class="hot" v-if="it.offer_times>0&&id==1" src="../../assets/hot.png" />

            <!--					<div class="can">-->
            <!--					-->
            <!--						<div>-->
            <!--							<p>订单编号：{{it.order_no}}</p>-->
            <!--						<p>下单时间：{{it.updated_at}} <b v-if="it.back_times"> 退回{{it.back_times}}次</b></p>-->
            <!--						</div>-->
            <!--						<div class="rit">-->
            <!--							-->
            <!--							{{it.citys}}-->
            <!--						</div>-->
            <!--						-->
            <!--					</div>-->
            <van-row class="can2" gutter='20' >
              <div class="lt">
                <div class="top">
                  <p class="seat" v-if="it.accept_seats==1">接受调坐</p>
                  <p class="seat" v-if="it.accept_seats==0">不接受调坐</p>
                  <div class="tit">{{it.movie_name}} <span>x{{it.ticket_count}}</span></div>
                </div>

                <p>{{it.show_time_txt}}</p>
                <p>{{it.cinemas}}</p>
                <p>{{it.halls}}</p>
                <p>{{it.seat_names}}</p>

                <!--						<p v-if="id==1">市场价：￥{{it.market_price}}</p>-->
                <p v-if="id>1">我的报价：￥{{it.offer_amount}}</p>
                <p class="inter" v-if="id>1">市场价：￥{{it.market_price}}</p>
                <p class="yell" style="display: flex;align-items: center;" v-if="it.hand"><img style="width: 0.5rem;" src="../../assets/time.png" /> 距离开场还有{{it.hand}}</p>
              </div>
              <div class="rt" v-if="id==2">
                <!--						{{it.status_txt}}-->
                <span v-if="it.status_txt=='已出票'">
              竞价成功
            </span>
                <span v-else-if="it.status_txt=='竞价成功'">
              竞价成功
            </span>
                <span style="color: red" v-else-if="it.status_txt=='已退回'">
              竞价失败
            </span>
                <span style="color: red" v-else-if="it.status_txt=='已关闭'">
              竞价失败
            </span>
                <span style="color: blue" v-else>
              	{{it.status_txt}}
            </span>
              </div>

            </van-row>
            <van-row class="can3 bottom1">
              <!--				<van-col v-if="it.hand" span="13">-->
              <!--				<div class="yell"><img src="../../assets/time.png" /> 距离开场还有{{it.hand}}</div>-->
              <!--					-->
              <!--				</van-col>-->
              <van-col span="10">
                <p v-if="id==1">市场价:￥{{it.market_price}}</p>
              </van-col>
              <van-col span="14" class="rit">
                <div class="ig" v-if="id==1" @click="wind(it)">忽略</div>
                <div class="qujian" v-if="id==1">建议报价区间￥{{it.min_price}}~￥{{it.max_price}}</div>
                <van-field placeholder="输入价格" v-if="id==1" v-model="it.number" type="number"><van-button slot="button" @click="baojia(it)" size="small" type="primary">报价</van-button></van-field>
                <!--					<div class="h-button" v-if="id==1">-->
                <!--						<router-link :to="'details?id='+it.order_no">报价</router-link>-->
                <!--            -->
                <!--						</div>-->


                <div class="h-button" v-if="id!=1">
                  <router-link :to="'details?id='+it.order_no">查看</router-link>

                </div>

              </van-col>
            </van-row>

          </li>

        </ul>

      </div>
      <div class="edu" v-if="user.store_state==0">
        <img src="../../assets/edu.png" />
        <p>您还不是商家，<router-link to="addAdr">注册商家</router-link></p>
      </div>
      <div class="edu" v-if="user.store_state==1">
        <img src="../../assets/edu.png" />
        <p>审核需要1-3个工作日，请耐心等待审核结果</p>
      </div>

    </div>

    <!--    <van-dialog v-model="tan1" title="出票时间缩短通知" confirm-button-text="知道了" show-cancel-button cancel-button-text="不再弹出" confirm="tanok()" cancel="tanno()">-->
    <!--      <p>现已将出票时间由45分钟缩短为30分钟,请商家留意避免因为超市产生不必要的损失,如果有建议或意见请与客服联系</p>-->
    <!--    </van-dialog>-->

  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast,Dialog  } from 'vant';
export default {
  components: {
    Title
  },
  data() {
    return {
      timedai:null,
      dainum:null,
      number:null,
      type:"1",
      title:'',
      id:1,
      keywords:'',
      images:[],
      info:'',
      user:'',
      page:1,
      news:[],
      notice:[],
      name:'',
      hans:'',
      sfznum:'',
      phone:'',
      tip:''

    };
  },  mounted() {

    this.sandRed()
    this.sandMate()
    this.getdainum()
  },

  methods: {
    getdainum(){
      this.$axios.get('stores/order_list',{params:{
          type:3,keywords:''
        }}).then((res)=>{
        console.log(res);
        let data=res.data;
        if(data.code==200){
          if(data.data.list.data.length!=0){
            this.dainum = data.data.list.data.length
            this.timedai=data.data.list.data[0].expire_time
            console.log(this.timedai)
            let a = new Date().getTime()
            this.timedai = this.timedai*1000-a
            console.log(this.timedai)
          }
        }
      })
    },
    baojia(it){
      if(it.number == null){

        Toast('请输入单价');
        return
      }


      this.$axios({
        method: "post",
        url: "stores/create_offer",
        data: {
          price:it.number,
          order_no:it.order_no
        },
      }).then((res) => {
        let data=res.data;

        if(data.code==200){

          this.sandMate()
          Toast(data.message);


        }else{
          Toast(data.message);

        }

      });
    },
    selecttype(type) {
      if(type=="2"){
        // window.location.href = "https://dyp.ylhwlkj.com";
        window.location.href = "https://xcx.ylhwlkj.com";
      }



    },
    nopop(){
      this.$axios({
        method: "post",
        url: "stores/nopop",
        data: {},
      }).then((res)=>{
        Toast('以后不在弹出');
      })
    },
    ctime(id){



      var now= Math.round(new Date().getTime()/1000).toString();


      var leftTime =  id-now ;


      if (leftTime >= 0) {

        let d = Math.floor(leftTime / 60 / 60 / 24);
        let h = Math.floor(leftTime  / 60 / 60 % 24);
        let m = Math.floor(leftTime  / 60 % 60);
        let s = Math.floor(leftTime % 60);

        if(d==0){
          return h+"时"+m+"分"
        }else{
          return d+"天" +h+"时"+m+"分"
        }



      }



    },sandRed(){
      if(this.$route.query.id){
        this.id = this.$route.query.id
      }

      this.$axios({
        method: "post",
        url: "stores/info",
        data: {},
      }).then((res)=>{
        let data=res.data;
        let user = JSON.parse(window.localStorage.getItem('user'));
        if(data.code==200) {
          data.data.store_info.token = user.token
          localStorage.setItem('user', JSON.stringify(data.data.store_info))
          this.user = data.data.store_info

          //弹窗提醒,确定键改为我知道了,取消键改为不再弹出
          if (this.user.no_pop != 1) {
            Dialog.alert({
              title: '出票时间缩短通知',
              message: '现已将出票时间由45分钟缩短为30分钟,请商家留意避免因为超市产生不必要的损失,如果有建议或意见请与客服联系',
              showCancelButton: true,
              confirmButtonText: '我知道了',
              cancelButtonText: '不再弹出',
            }).then(() => {
              // on confirm
            }).catch(() => {
              this.nopop()
            });
          }
        }
      })

    },

    sandMate(){
      this.news=[]
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.$axios.get('stores/order_list',{params:{
          type:this.id,keywords:this.keywords
        }}).then((res)=>{
        // let res={};
        // res.data={"code":200,"message":"\u6210\u529f","data":{"list":{"current_page":1,"data":[{"id":613,"order_no":"D20221207132453531004","max_price":"40.1","min_price":"1","updated_at":"2022-12-07 13:24:55","citys":"\u676d\u5dde","ticket_count":1,"movie_name":"\u5760\u843d","seat_names":"","accept_seats":1,"show_time":1670402400,"close_time":1670408760,"expire_time":1670390875,"cinemas":"\u4e34\u5b89\u6a2a\u5e97\u7535\u5f71\u57ce","halls":"6\u53f7\u6fc0\u5149\u5385(\u5e7f\u544a\u3001\u51a0\u540d\u5385\u62db\u5546)","market_price":"27 x 1","offer_status":0,"offer_times":1,"win_store_id":0,"offer_record_id":2425,"offer_amount":0.01,"store_id":121,"status_txt":"\u7ade\u4ef7\u4e2d","back_times":0,"show_date":"2022-12-07","show_time_txt":"12-07 16:40~18:26"}],"first_page_url":"https:\/\/dyp.ylhwlkj.com\/api\/stores\/order_list?page=1","from":1,"last_page":1,"last_page_url":"https:\/\/dyp.ylhwlkj.com\/api\/stores\/order_list?page=1","next_page_url":null,"path":"https:\/\/dyp.ylhwlkj.com\/api\/stores\/order_list","per_page":20,"prev_page_url":null,"to":1,"total":1}}}
        console.log(res);
        let data=res.data;
        if(data.code==200){
          if(data.data.list.data.length==0&&this.page==1){
            this.tip='暂无内容'
            return
          }

          if(data.data.list.data.length==0&&this.page!=1){
            this.tip='没有更多了'
            return
          }
          this.tip='查看更多'
          this.news=this.news.concat(data.data.list.data);
          if(this.id==1||this.id==2){
            this.news.forEach(item=>{
              item['hand'] = this.ctime(item.show_time)
            })

            setTimeout(this.sandMate, 60000);

          }


        }
      })



    },sandAlt(){

      this.news=[]
      this.sandMate()

    },wind(id){
      this.$axios({
        method: "post",
        url: "stores/ignore_order",
        data: {order_no:id.order_no},
      }).then((res)=>{
        let data=res.data;

        if(data.code==200){
          Toast(data.message);
          this.news=[]
          this.sandMate()

        }else{
          Toast(data.message);
        }
      })

    }
  }
};
</script>
<style lang="scss" scoped>
.bottom1{
  justify-content: center;
  align-items: center;
  display: flex;
}
.index {

  width: 100%;
  overflow: hidden;
  background: #F1F1F1;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  img{
    width: 100%;
  }

}

.info{
  padding: 30px;
  background: #F6F6F6;
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #808080;
  align-items: center;
  .more{
    img{
      width: 21px;
      height: 36px;
    }

  }
  .l1{
    span{
      color: #2892FF;
      font-size: 28px;
      margin-right: 20px;
    }
  }
  .l2{
    line-height: 60px;
    display: flex;
    align-items: center;
    img{
      width: 33px;
      height: 24px;
      margin-right: 10px;
    }
  }
}
.menu{
  margin-top: 30px;
  ul{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    li{
      width: 25%;

      img{
        width: 70%;
      }
      p{
        line-height:70px;
      }
    }
  }

}
.notice{
  background: #FFE6D8;
  height: 72px;
  font-size: 28px;
  display: flex;
  align-items: center;
  color: #FF5E00;
  img{
    width: 30px;
    height:30px;
    margin-right: 10px;
    margin-left: 30px;
  }
}

.news{
  background: #FFFFFF;
  border-radius: 20px;
  padding:30px 30px 0 30px;
  margin-top: 50px;
  font-size: 28px;
  margin-bottom: 30px;
  .tit{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F1F1F1;
    padding-bottom: 20px;
    .more{
      img{
        width: 16px;
        height:29px;
      }

    }
    .sub{
      display: flex;
      align-items: center;
      color: #2892FF;
      img{
        width: 39px;
        height: 40px;
        margin-right: 20px;
      }

    }
  }

  .cont{
    li{
      border-bottom: 1px solid #F1F1F1;
      display: flex;
      padding: 30px 0;
      text-align: left;
      img{
        width: 271px;
        height: 193px;
        margin-right: 20px;
      }
      h4{
        outline: 1;
        font-size: 30px;
      }
      p{
        color: #7E7E7E;
        font-size: 26px;
        margin: 20px 0;
      }
    }
  }
  .cont2{
    ul{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li{
        width: 30%;
        img{
          width: 100%;
          margin: 20px 0;
        }
        .txt{
          font-size: 24px;
          margin-bottom: 20px;
        }
      }
    }
  }

}
.act-br{
  width:100%;
  margin-top: 50rpx;
  img{
    width: 100%;
  }
}
.index-banner{
  background-color: #FFFFFF;
}
.index-nav{
  background: #000000;
  color: #FFFFFF;
  padding: 30px 0;
  text-align: center;
  ul{
    display: flex;

    justify-content:space-between;
    li{
      width: 100%;

      border-right: 1px solid #444444;

      p{
        line-height: 50px;
      }
      a{
        color: #FFFFFF;
      }
    }
  }
}
.index-nav2{
  background: #FFFFFF;
  color: #000000;
  border-bottom: 1px solid #DDDDDD;
  padding: 30px 0;
  text-align: center;
  ul{

    display: flex;
    justify-content:space-evenly;
    li{
      width: 100%;
      border-right: 1px solid #DDDDDD;

      p{
        line-height: 50px;
      }
      .act{
        color: #999999;
      }
    }
  }
}
.index-product{
  margin: 20px;

  font-size: 28px;
  color: #000000;

  .tit{
    line-height: 60px;
    display: flex;
    align-items: center;
    .zik{
      width: 4px;
      height: 28px;
      background: #000000;
      margin-right: 20px;
    }
  }
  .con{

    ul{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li{
        background: #FFFFFF;
        position: relative;
        margin-bottom: 20px;
        width:100%;
        border-radius: 10px;
        padding:0 20px;
        .hot{
          width: 40px;
          height: 50px;
          position: absolute;
          right: 20px;
        }
        .wave{
          width: 120px;
          height: 48px;
          background: #FF5E00;
          border-radius: 24px 0px 0px 24px;
          text-align: center;
          line-height: 48px;
          color: #FFFFFF;
          position: absolute;
          right: 0;
          top: 10px;
        }
        .tip{
          position: absolute;
          left: 15px;
          top: -18px;
        }
        .tu{
          text-align: center;
          overflow: hidden;
          height: 230px;
          img{
            width: 100%;
          }
        }
        .txt{
          padding: 20px;
          .bot{
            height:70px;
            overflow: hidden;
          }
          .money{
            color: #7D7D7D;
            margin-top: 10px;
          }
        }
      }
    }
    .button{
      width: 200px;
      height: 60px;
      background: #444444;
      color: #ffffff;
      text-align: center;
      line-height: 60px;
      margin: 20px auto;
    }
  }
}
.index-bar{
  img{
    width: 100%;
  }
}
.pro-tit{
  background: #FFFFFF;
  text-align: center;
  line-height: 40px;
  padding: 20px 0;
  h3{
    font-size: 36px;
  }
  p{
    font-size: 24px;
  }
}
.pro-tab{
  border-top: 1px solid #EEEEEE;
  border-bottom: 1px solid #EEEEEE;
}
.can{

  border-bottom: 1px solid #EAEAEA;
  display: flex;
  justify-content: space-between;
  height: 130px;
  align-items: center;
  color: #7D7D7D;
  font-size: 24px;
  p{
    line-height: 35px;
  }
  b{

    color: #F10018;
    font-weight: 400;
    margin-right: 20px;
  }
  .rit{
    color: #222222;
    font-size: 28px;
    margin-top: 40px;

  }

}
.can2{
  border-bottom: 1px solid #EAEAEA;
  padding: 20px 0;
  display: flex;
  justify-content:space-between;
  align-items: center;
  width: 100%;

  .tit{
    font-size: 36px;
    color: #222222;
    margin-left: 0.2rem;
    span{
      color: #FF5E00;
      margin-left: 10px;
      font-size: 24px;
    }
  }
  .lt{
    .top{
      display: flex;
      align-items: center;
    }
    flex: 1;
    p{
      font-size: 24px;
      color: #999999;
      line-height: 40px;
      span{
        color: #FF5E00;
      }
    }
    .seat{
      color: #ffffff;
      background: blue;
      padding: 0.05rem 0.2rem;
      border-radius: 0.15rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .rt{
    width: 186px;
    height: 48px;
    background: #F4F4F4;
    border-radius: 24px;
    display:flex;
    align-items:center;
    color: #7D7D7D;
    justify-content: center;
    img{
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

  }

}
.can3{
  padding: 3px 0;
  p{
    line-height: 65px;
  }
  .yell{
    display: flex;
    align-items: center;
  }
  img{
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .inter{
    color: #999999;
    font-size: 24px;
    line-height: 20px;
  }
  .rit{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .ig{
      color: #EEA600;
      //margin-right:50px;
      width: 1rem;
    }
    .qujian{
      position: absolute;
      z-index: 1;
      bottom: 1.7rem;
      font-size: 0.3rem;
      right: 0.7rem;
      color: #00000094;
    }
    .app{
      background: #FFBB1D;
    }
    button{
      margin-left: 20px;
    }
  }
}
.h-button{
  width: 128px;
  height: 64px;
  background: #FF5E00;
  text-align: center;
  line-height: 64px;
  border-radius: 32px;
  font-size: 24px;
  color: #ffffff;
  a{
    color: #ffffff;
  }
}
.mem-con{
  background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/6c557c89-a107-489e-a719-2fb92b0fd379.png) no-repeat;
  background-size: 100%;
  height: 200px;
  font-size: 24px;
  color: #fff;
  padding: 30px;
  .mem-l1{

    padding: 40px 0;
    h3{
      margin-top: 30px;
      font-size: 34px;
      color: #fff;
    }
    .head{
      width: 100px;
      height: 100px;
      margin-left: 30px;
      border-radius:100px;
    }
    .set{
      width: 42px;
    }
    .shop{
      width: 120px;
      height: 36px;
      border-radius: 18px;
      color: #7D7D7D;
      background: #fff;
      text-align: center;
      font-size: 24px;
      margin-top: 15px;
    }
    .mem-sim{
      text-align: center;
      margin-top: 20px;
      h4{
        color: #fff;
        font-size: 40px;
        font-weight: normal;

      }
      p{
        color: #fff;
      }
    }

  }

}
.word{
  display: flex;
  margin: 0 20px;
  align-items: center;
  justify-content: space-between;
  .m-search{
    display: flex;
    align-items: center;
    width:472px;
    height:64px;
    background:#FFFFFF;
    border-radius:64px;
    margin: 18px 0px;
    font-size: 24px;
    color: #7D7D7D;
    padding: 0 30px;
    input{
      border: none;
      flex: 1;
    }
    img{
      margin-right: 20px;
      width: 30px;
      height: 30px;
    }
  }
}

.edu{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img{
    width: 200px;
    height: 200px;
    margin: 20px 0;
  }
  p{
    color: #999999;
    a{
      color: #FF5E00;
    }
  }
}
</style>
